<template>
  <layout class="payment-list-page-container">
    <div class="w-full flex adm-container">
      <div class="w-3/4 sm:hidden lg:block">&nbsp;</div>
      <div class="sm:w-full lg:w-1/4">
        <pt-datepicker
          :value="date"
          :range="true"
          :week-range="true"
          :show-next-month-dates="true"
          :show-prev-month-dates="true"
          :disabled-dates="disabledDates"
          :close-on-range-select="true"
          class="flex flex-col flex-1 sm:pl-0 lg:pl-4"
          @selected="onDateChange"
        />
      </div>
    </div>
    <div class="w-full flex flex-col adm-container relative">
      <pt-list>
        <div class="font-bold bg-transparent sm:hidden lg:flex sm:p-0 lg:p-4 sm:border-b-0 lg:border-b">
          <div class="w-1/4">Statement Start Date</div>
          <div class="w-1/4">Statement End Date</div>
          <div class="w-1/4">Total Payments</div>
          <div class="w-1/4">View</div>
        </div>
        <pt-list-item
          v-for="(paymentRow, paymentIndex) in paymentList"
          :key="paymentIndex + 1"
        >
          <div class="flex flex-1 sm:flex-col lg:flex-row">
            <div class="sm:w-full lg:w-1/4 sm:py-1 lg:py-0">
              <span class="font-bold lg:hidden sm:mr-2">Processing Status:</span>
              <span class="lg:w-full lg:text-right">{{ paymentRow.start_date }}</span>
            </div>
            <div class="sm:w-full lg:w-1/4 sm:py-1 lg:py-0">
              <span class="font-bold lg:hidden sm:mr-2">Ending At:</span>
              <span class="lg:w-full lg:text-right">{{ paymentRow.end_date }}</span>
            </div>
            <div class="sm:w-full lg:w-1/4 sm:py-1 lg:py-0">
              <span class="font-bold lg:hidden sm:mr-2">Total Payments</span>
              <span class="lg:w-full lg:text-right">{{ CurrencyConverter(paymentRow.net_payout) }}</span>
            </div>
            <div :class="{ 'sm:w-full lg:w-1/4 sm:py-1 lg:py-0': true }">
              <span class="lg:w-full lg:text-right">
                <router-link
                  :to="`/captain-management/payment-statements/invoice/start/${paymentRow.start_date}/end/${paymentRow.end_date}`"
                  class="font-bold no-underline text-primary"
                >
                  View Statement
                </router-link>
              </span>
            </div>
          </div>
        </pt-list-item>
      </pt-list>

      <table-placeholder
        :is-syncing="tableLoader"
        :data-length="paymentList.length"
        loader-class="text-black"
      />
    </div>
  </layout>
</template>

<script>
import { PtPagination } from '@pathao/ui-components/esm/Pagination';
import { PtDatepicker } from '@pathao/ui-components/esm/Datepicker';
import { PtList, PtListItem } from '@pathao/ui-components/esm/List';
import Layout from '@layouts/main';
import TablePlaceholder from '../../../../components/custom/TablePlaceholder';
import makeRequest from '../../../../utils/apiRequest';
import RunningWeek from '../../../../utils/running-week';
import SelectedDates from '../../../../utils/selected-dates';
import CurrencyConverter from '../../../../plugins/CurrencyConverter';
import Config from '../../../../config/index';
import PaginationConfig from '../../../../config/pagination';
import startOfWeek from 'date-fns/start_of_week';
import addDays from 'date-fns/add_days';

export default {
  name: 'PaymentStatements',
  page: {
    title: 'Payment Statements',
  },
  components: { PtPagination, Layout, TablePlaceholder, PtDatepicker, PtList, PtListItem },
  mixins: [ CurrencyConverter ],
  data() {
    return {
      date: RunningWeek(process.env.NODE_ENV !== 'production' ? 0 : -7),
      selectedDateRangeType: 'weekly',
      tableLoader: false,
      paymentList: [],
      isLoadingListData: false,
      disabledDates: {
        from: startOfWeek(addDays(new Date(), process.env.NODE_ENV === 'production' ? 0 : 7)),
      },
    };
  },
  mounted() {
    this.fetchPaymentStatements();
  },
  methods: {
    fetchPaymentStatements(page = PaginationConfig.CURRENT_PAGE, per_page = PaginationConfig.PAGE_SIZE) {
      const selectedDates = SelectedDates(this.date);
      const paymentMeta = {
        url: `${Config.api.baseURL}api/partners/payment-statements/list`,
        params: {
          page,
          per_page,
          ...selectedDates,
        },
      };

      this.tableLoader = true;
      this.paymentList = [];

      makeRequest(paymentMeta)
        .then((response) => {
          this.paymentList = response.data;
          this.tableLoader = false;
        })
        .catch((errorResponse) => {
          this.tableLoader = false;
          this.$notification.error('Error fetching Payment statements');
          console.error(errorResponse);
        });
    },
    onDateChange(newDate) {
      this.date = newDate;
      this.fetchPaymentStatements();
    },
  },
};
</script>
